module.exports = __webpack_public_path__ + "img/shrine_tech_Normal_ua.7ff606a6.webp";